export const DEFAULT_INDEX = 'projects';
